import React from 'react';
import splashLogo from '../../assets/icons/logo.svg';
import './splash.css';
import '../../root.css';

const Splash = () => {
    return ( <>
    <div className="splash-backdrop">
        <img className='splash-logo' src={splashLogo} alt="Cairo International Book Fair logo" />
    </div>
    </> );
}
 
export default Splash;